import CreateIntegrationForm from './component'

export default CreateIntegrationForm
